import { render, staticRenderFns } from "./WizardFormHeader.vue?vue&type=template&id=700eb4a9&scoped=true&"
import script from "./WizardFormHeader.vue?vue&type=script&lang=js&"
export * from "./WizardFormHeader.vue?vue&type=script&lang=js&"
import style0 from "./WizardFormHeader.vue?vue&type=style&index=0&id=700eb4a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700eb4a9",
  null
  
)

export default component.exports